export default "__VITE_ASSET__91779e94__"